import React from 'react';
import { Container } from 'bulma-react';
import {
  ProfileBanner,
} from '../components';

export function About(props) {
  return (
    <Container className="app">
      <ProfileBanner />
      about
    </Container>
  );
}




// WEBPACK FOOTER //
// ./src/container/about.js